class AnnualReport {
  constructor(elem) {
    this.body = elem[0];

    this.DELTA = 80;
    this.lastScrollTop = 0;
    this.navbar = this.body.querySelector('nav.navbar');

    this.mobileMenuButton = this.body.querySelector(".mobile-menu-button");
    this.mobileMenu = this.body.querySelector(".mobile-menu");
    this.mobileMenuLinks = [...this.mobileMenu.querySelectorAll("a")];

    this.anchorLinks = this.body.querySelectorAll("a[href*=\\#]");

    this.bindEvents();
  }

  bindEvents() {
    (this.navbar && window) && window.addEventListener('scroll', () => this.toggleNavbarOnScroll());

    this.mobileMenuButton.addEventListener("click", () => this.toggleMenu());

    this.mobileMenuLinks.forEach(link => {
      link.addEventListener("click", () => this.toggleMenu());
    });

    this.anchorLinks.forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault();

        const id = link.getAttribute("href").split("#")[1];
        const hash = "#" + id.split(" ").join("%20");

        window.history.pushState(null, null, hash);

        this.body.querySelector(`[id='${id}']`).scrollIntoView({
          behavior: "smooth",
        });
      });
    });

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (
          entry.isIntersecting &&
          this.mobileMenu.classList.contains("open")
        ) {
          this.body.classList.add("locked");
        } else {
          this.body.classList.remove("locked");
          this.mobileMenu.classList.remove("open");
          this.mobileMenuButton.classList.remove("open");
        }
      });
    });
    observer.observe(this.mobileMenu);
  }

  toggleNavbarOnScroll() {
    var currentScroll = document.scrollingElement.scrollTop || document.documentElement.scrollTop || 0;

    if (Math.abs(currentScroll - this.lastScrollTop) < this.DELTA) {
      return;
    }

    (currentScroll > this.lastScrollTop && !this.mobileMenu.classList.contains("open"))
      ? this.navbar.classList.add('-passive')
      : this.navbar.classList.remove('-passive');

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  toggleMenu() {
    this.mobileMenuButton.classList.toggle("open");
    this.mobileMenu.classList.toggle("open");
  }
}

export default AnnualReport;
